export default __webpack_public_path__ + "static/media/sweetWord2.93f1083b.png";